import Vue from 'vue'
import VueLocalStorage from "vue-localstorage";
import App from './App.vue'
import router from './router'
import firebase from 'firebase'
import platformSettings from '~config/settings'
import BootstrapVue from "bootstrap-vue";
import store from './store';
import {initSentry} from "@/utils/sentry";
import * as rules from 'vee-validate/dist/rules';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';

if (!platformSettings.disableSentry) {
  initSentry()
}

Vue.use(BootstrapVue);
Vue.use(VueLocalStorage);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.config.productionTip = false

firebase.initializeApp(platformSettings.firebaseConfig)

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

Vue.mixin({
  methods: {
    localizedCurrency(val, curr) {
      const lang = navigator.language
      const c = curr === '€' ? 'EUR' : curr
      return new Intl.NumberFormat(lang, { style: 'currency', currency: c || 'EUR' }).format(val)
    }
  },
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
